import { Action } from '@ngrx/store';
import { TradeBlotter } from '../../model/TradeBlotter';

export enum TradeBlotterActionTypes {
  InitTradeBlotters = 'InitTradeBlotters',
  AddTradeBlotter = 'AddTradeBlotter',
  RemoveTradeBlotter = 'RemoveTradeBlotter',
  UpdateTradeBlotter = 'UpdateTradeBlotter',
}

export class InitTradeBlotters implements Action {
  readonly type = TradeBlotterActionTypes.InitTradeBlotters;

  constructor(public payload: any) {
  }
}

export class AddTradeBlotter implements Action {
  readonly type = TradeBlotterActionTypes.AddTradeBlotter;

  constructor(public payload: TradeBlotter) {
  }
}

export class RemoveTradeBlotter implements Action {
  readonly type = TradeBlotterActionTypes.RemoveTradeBlotter;

  constructor(public payload: string) {
  }
}

export class UpdateTradeBlotter implements Action {
  readonly type = TradeBlotterActionTypes.UpdateTradeBlotter;

  constructor(public payload: TradeBlotter) {
  }
}

export type TradeBlotterActions =
  InitTradeBlotters |
  AddTradeBlotter |
  RemoveTradeBlotter |
  UpdateTradeBlotter;
